<template>
    <div>
        <h2>{{ $t("settings.smart-routing.assignables.header") }}</h2>

        <b-form-group
            id="fieldset-users"
            :description="$t('settings.smart-routing.assignables.users.description')"
            :label="$t('settings.smart-routing.assignables.users.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
        >
            <app-user-team-dropdown />
        </b-form-group>
        <b-form-group
            id="fieldset-tags"
            :description="$t('settings.smart-routing.assignables.tags.description')"
            :label="$t('settings.smart-routing.assignables.tags.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
        >
            <v-select v-model="currentRoute.tags" :options="tags" label="name" multiple />
        </b-form-group>
        <b-form-group
            id="fieldset-labels"
            :description="$t('settings.smart-routing.assignables.labels.description')"
            :label="$t('settings.smart-routing.assignables.labels.label')"
            content-cols-lg="7"
            content-cols-sm
            label-cols-lg="3"
            label-cols-sm="4"
        >
            <v-select v-model="currentRoute.labels" :options="labels" label="name" multiple />
        </b-form-group>
    </div>
</template>
<script>
import { BFormGroup, BFormInput, BFormRadioGroup, BFormTags } from "bootstrap-vue";
import { ValidationProvider } from "vee-validate";
import vSelect from "vue-select";
import useTags from "../useTags";
import useUsers from "@/composables/useUsers";
import AppUserTeamDropdown from "./userTeamDropdown";
import useRoutes from "@/views/modules/settings/smart-routing/useRoutes";
import { useContactsStore } from "@/store/useContactsStore";

export default {
    components: {
        BFormGroup,
        BFormInput,
        BFormTags,
        BFormRadioGroup,
        ValidationProvider,
        vSelect,
        AppUserTeamDropdown,
    },
    setup() {
        const { tags, fetchTags } = useTags();
        const { fetchLabels, labels } = useContactsStore();
        const { fetchUsers, fetchTeams } = useUsers();
        const { currentRoute } = useRoutes();
        fetchLabels();
        fetchTags();
        fetchUsers({
            s: {
                $and: [{ role: { $ne: "api" } }, { role: { $ne: "saysimple" } }, { active: { $eq: 1 } }],
            },
            sort: "name,ASC",
        });
        fetchTeams({
            join: "teamUsers",
            sort: "name,ASC",
        });

        return {
            tags,
            labels,
            currentRoute,
        };
    },
};
</script>
